function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1318",
  "data-name": "Group 1318",
  transform: "translate(-39.75 -218)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Component_34_102",
  "data-name": "Component 34 \\u2013 102",
  transform: "translate(254.509 253.715) rotate(180)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  x1: 17.236,
  transform: "translate(0.273 7.218)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  x2: 7.218,
  y2: 7.218,
  transform: "translate(7.218) rotate(90)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  y1: 7.218,
  x2: 7.218,
  transform: "translate(7.218 7.218) rotate(90)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Component_34_103",
  "data-name": "Component 34 \\u2013 103",
  transform: "translate(138.509 253.715) rotate(180)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10-2",
  "data-name": "Line 10",
  x1: 17.236,
  transform: "translate(0.273 7.218)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11-2",
  "data-name": "Line 11",
  x2: 7.218,
  y2: 7.218,
  transform: "translate(7.218) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_12-2",
  "data-name": "Line 12",
  y1: 7.218,
  x2: 7.218,
  transform: "translate(7.218 7.218) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1180",
  "data-name": "Group 1180",
  transform: "translate(0 -7)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1179",
  "data-name": "Group 1179",
  transform: "translate(41 227)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_989",
  "data-name": "Group 989",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_599",
  "data-name": "Path 599",
  d: "M2.9-.305H26.3V-23.71H2.9Z",
  transform: "translate(-2.898 23.71)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_990",
  "data-name": "Group 990",
  transform: "translate(0 28.594)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_600",
  "data-name": "Path 600",
  d: "M2.9,13.131H26.3V-10.274H2.9Z",
  transform: "translate(-2.898 10.274)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_991",
  "data-name": "Group 991",
  transform: "translate(28.594)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_601",
  "data-name": "Path 601",
  d: "M17-.305H40.4V-23.71H17Z",
  transform: "translate(-16.995 23.71)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_604",
  "data-name": "Path 604",
  d: "M20.418-20.169h7.371",
  transform: "translate(-12.696 30.773)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_992",
  "data-name": "Group 992",
  transform: "translate(28.594 28.594)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605",
  "data-name": "Path 605",
  d: "M22.954-11.885h15.64V11.521H15.188V-.2H29.873",
  transform: "translate(-15.188 11.885)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1175",
  "data-name": "Group 1175",
  transform: "translate(5.173 43.062) rotate(-90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605-2",
  "data-name": "Path 605",
  d: "M3.539,0h7.127V13.71H0V6.844H6.692",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1174",
  "data-name": "Group 1174",
  transform: "translate(34.721 5.106)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605-3",
  "data-name": "Path 605",
  d: "M19.568-11.885h8.821V-.212h-13.2",
  transform: "translate(-15.188 11.885)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1177",
  "data-name": "Group 1177",
  transform: "translate(16.521 5.106) rotate(90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605-4",
  "data-name": "Path 605",
  d: "M4.38,0H13.2V11.673H0",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_760",
  "data-name": "Path 760",
  d: "M0,0H14.341",
  transform: "translate(47.911 33.891) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_759",
  "data-name": "Path 759",
  d: "M6.32-6.733H21.2",
  transform: "translate(22.107 40.624)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_761",
  "data-name": "Path 761",
  d: "M20.418-20.169h5.544",
  transform: "translate(15.14 66.515)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1176",
  "data-name": "Group 1176",
  transform: "translate(5.136 48.169) rotate(-90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_762",
  "data-name": "Path 762",
  d: "M0,0H9.449",
  transform: "translate(0 0.001) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_763",
  "data-name": "Path 763",
  d: "M0,0H4.814",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1178",
  "data-name": "Group 1178",
  transform: "translate(10.212 5.106)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_762-2",
  "data-name": "Path 762",
  d: "M0,0H8.3",
  transform: "translate(0 0.001) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_763-2",
  "data-name": "Path 763",
  d: "M20.418-20.169h9.61",
  transform: "translate(-20.418 20.169)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1013",
  "data-name": "Group 1013",
  transform: "translate(137.037 -180)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_750",
  "data-name": "Path 750",
  d: "M2.25-2.25H54.117",
  transform: "translate(22.713 455.209)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_593",
  "data-name": "Path 593",
  d: "M18.456-64.144H28.829",
  transform: "translate(25.822 476.111)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_748",
  "data-name": "Path 748",
  d: "M49.226-56.256a2.745,2.745,0,0,0-.692-1.841,2.255,2.255,0,0,0-1.67-.763H10.1a2.264,2.264,0,0,0-1.676.765,2.755,2.755,0,0,0-.694,1.848V-9.468H49.226Z",
  transform: "translate(22.011 462.468)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_749",
  "data-name": "Path 749",
  d: "M18.456-64.144H39.2",
  transform: "translate(22.165 463.145)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1012",
  "data-name": "Group 1012",
  transform: "translate(35.433 426.23)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1011",
  "data-name": "Group 1011"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1009",
  "data-name": "Group 1009"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_57",
  "data-name": "Line 57",
  x2: 31.12,
  transform: "translate(0 5.187)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_65",
  "data-name": "Line 65",
  x2: 31.12,
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_58",
  "data-name": "Line 58",
  x2: 31.12,
  transform: "translate(0 10.373)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_59",
  "data-name": "Line 59",
  x2: 31.12,
  transform: "translate(0 15.56)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_60",
  "data-name": "Line 60",
  x2: 31.12,
  transform: "translate(0 20.747)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1008",
  "data-name": "Group 1008",
  transform: "translate(15.56) rotate(90)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_61",
  "data-name": "Line 61",
  x2: 20.747,
  transform: "translate(0)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_62",
  "data-name": "Line 62",
  x2: 20.747,
  transform: "translate(0 5.187)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_63",
  "data-name": "Line 63",
  x2: 20.747,
  transform: "translate(0 10.373)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_64",
  "data-name": "Line 64",
  x2: 20.747,
  transform: "translate(0 15.56)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1010",
  "data-name": "Group 1010",
  transform: "translate(66.553 426.23) rotate(90)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_61-2",
  "data-name": "Line 61",
  x2: 20.747,
  transform: "translate(0)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_62-2",
  "data-name": "Line 62",
  x2: 20.747,
  transform: "translate(0 5.187)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_63-2",
  "data-name": "Line 63",
  x2: 20.747,
  transform: "translate(0 10.373)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_64-2",
  "data-name": "Line 64",
  x2: 20.747,
  transform: "translate(0 15.56)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_591",
  "data-name": "Path 591",
  d: "M26.138-18.9H39.1v-6.837H26.138Z",
  transform: "translate(27.431 437.473)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1181",
  "data-name": "Group 1181",
  transform: "translate(276.713 283.145)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_589",
  "data-name": "Path 589",
  d: "M53.482-56.256a2.6,2.6,0,0,0-.763-1.841,2.6,2.6,0,0,0-1.841-.763H10.345a2.613,2.613,0,0,0-1.848.765,2.613,2.613,0,0,0-.765,1.848v46.78h45.75Z",
  transform: "translate(-0.703 -0.678)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_590",
  "data-name": "Path 590",
  d: "M16.451-40.392H47v-9.773H16.451Z",
  transform: "translate(-1.821 -1.792)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_591-2",
  "data-name": "Path 591",
  d: "M26.138-5.946H39.8v-19.79H26.138Z",
  transform: "translate(-3.063 -4.925)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_592",
  "data-name": "Path 592",
  d: "M2.25-2.25H57.1",
  transform: "translate(0 -7.936)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_593-2",
  "data-name": "Path 593",
  d: "M18.456-64.144H45.048",
  transform: "translate(-2.078)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

var SvgAddNewUnit = function SvgAddNewUnit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295.061,
    height: 56,
    viewBox: "0 0 295.061 56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddNewUnit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-new-unit.92f1c8db.svg";
export { ForwardRef as ReactComponent };